"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const container = {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(52, 52, 52, 0.8)',
};
const contentIos = {
    width: 270,
    flexDirection: 'column',
    borderRadius: 13,
    overflow: 'hidden',
    backgroundColor: '#efeff4',
};
const contentAndroid = {
    flexDirection: 'column',
    borderRadius: 3,
    padding: 16,
    margin: 16,
    backgroundColor: 'white',
    overflow: 'hidden',
    elevation: 4,
    minWidth: 300,
};
const titleAndroid = {
    fontWeight: 'bold',
    fontSize: 18,
    color: 'black',
};
const titleIos = {
    color: 'black',
    textAlign: 'center',
    fontSize: 18,
    fontWeight: '600',
};
const footerAndroid = {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginTop: 4,
};
const footerIos = {
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderTopColor: '#A9ADAE',
    borderTopWidth: 1,
    height: 46,
};
const buttonAndroid = {
    justifyContent: 'center',
    alignItems: 'center',
    margin: 10,
};
const buttonIos = {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    margin: 10,
};
const buttonTextAndroid = {
    textAlign: 'center',
    fontSize: 14,
    color: '#008080',
    fontWeight: '500',
};
const contentWrapperAndroid = {
    backgroundColor: 'white',
    borderRadius: 6,
    marginHorizontal: 20,
    marginBottom: 20,
    paddingHorizontal: 8,
    alignItems: 'center',
};
const contentWrapperIos = {
    marginHorizontal: 10,
    marginBottom: 20,
    alignItems: 'center',
};
exports.default = {
    modal: {
        flex: 1,
        marginLeft: 0,
        marginRight: 0,
        marginTop: 0,
        marginBottom: 0,
        backgroundColor: 'transparent',
    },
    container,
    contentIos,
    contentAndroid,
    headerIos: {
        margin: 18,
    },
    headerAndroid: {
        margin: 12,
    },
    footerAndroid,
    footerIos,
    titleAndroid,
    titleIos,
    descriptionAndroid: {
        color: '#33383D',
        fontSize: 16,
        marginTop: 10,
    },
    descriptionIos: {
        textAlign: 'center',
        color: 'black',
        fontSize: 13,
        marginTop: 4,
    },
    contentWrapperAndroid,
    contentWrapperIos,
    buttonAndroid,
    buttonIos,
    buttonTextAndroid,
    buttonTextIos: {
        textAlign: 'center',
        fontSize: 17,
        backgroundColor: 'transparent',
    },
};
